/// <reference path="../../typings/index.d.ts" />

module monitoringApp.common {
    interface IDataAccessService {
        getSuiteRunResult(testSuiteID: number): ng.resource.IResourceClass<monitoringApp.entities.IRunSuiteResultResource>;
        getCaseHistory(caseId: number, date: string): ng.IPromise<entities.ICaseHistoryResult>;
        getSuiteHistory(suiteId: number, date: string): ng.IPromise<entities.ISuiteHistoryResult>;
        getSuiteReport(suiteId: number, date: string): ng.IPromise<entities.ISuiteReportResult>;

    }

    export class DataAccessService implements IDataAccessService {

        static $inject = ["$resource", "$http"];
        private token = "";
        constructor(private $resource: ng.resource.IResourceService, private $http: ng.IHttpService) {
            this.token = $("meta[name=csrf-token]").attr('content');
          $http.defaults.headers.common['X-CSRFToken'] = this.token;
          
        }
        getSuiteRunResult = (testSuiteID: number) => {
            //result: monitoringApp.entities.IRunSuiteResultResource = new monitoringApp.entities.IRunSuiteResultResource();
            return this.$resource("/getRunResults/:id", {
                id: testSuiteID
            });
        }

        //POST, cannot use $resource
        getCaseHistory = (caseId: number, date: string) => {
            return this.$http.post(`/reports/case/${caseId}/byDate/${date}`, null).then((result) => {
                return result.data as entities.ICaseHistoryResult;
            });
        }

        //this one is a form
        getSuiteHistory = (suiteId: number, date: string) => {
            return this.$http({
                method: 'POST',
                url: `/suite/${suiteId}/getHistory`,
                data: $.param({ date: date }),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((result) => {
               
                return result.data as entities.ISuiteHistoryResult;
            });
        }

        //POST, cannot use $resource
        getSuiteReport = (suiteId: number, date: string) => {
            return this.$http.post(`/reports/suite/${suiteId}/byDate/${date}`, null).then((result) => {
                (result.data as entities.ISuiteReportResult).testCases;
                return result.data as entities.ISuiteReportResult;
            });
        }

        deleteResultType = (id: number) => {
            return this.$http({
                method: 'POST',
                url: `resultType/${id}`,
                data: $.param({  _method:"DELETE", _token: this.token }),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });
            
        }


        updateResultType = (data: any) => {
            data._method = "PUT";
            data._token = this.token;
           return this.$http({
                method: 'POST',
                url: `/admin/resultType/${data.id}`,
                data: $.param(data),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });
        }

         createResultType = (data: any) => {
            data._token = this.token;
            data.method = 'POST';
           return this.$http({
                method: 'POST',
                url: `/admin/resultType`,
                data: $.param(data),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });
        }

       

    }

    angular.module('common.services').service('dataAccessService', monitoringApp.common.DataAccessService);
}


